import styled from '@emotion/styled';
import NextLink from 'next/link';
import { spacing, fontSize } from 'presentations/views/styles';
import { gray01, gray02 } from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import { ResourceTaxonomyItem } from 'presentations/api/schema/resources';
import { resourceTagPath } from 'presentations/routes/path';

export interface Props {
  tags: ResourceTaxonomyItem[];
}

export default function Component(props: Props) {
  if (props.tags.length === 0) {
    return null;
  }

  return (
    <TagList>
      {props.tags.map((tag) => (
        <NextLink
          key={tag.slug}
          href={resourceTagPath({ tag: tag.slug })}
          passHref
        >
          <TagItem>
            <TagIcon name="tag" />
            <Tag>{tag.name}</Tag>
          </TagItem>
        </NextLink>
      ))}
    </TagList>
  );
}

const TagList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const TagItem = styled.a`
  display: flex;
  align-items: center;
`;

const Tag = styled.div`
  margin: 0 ${spacing(24)} 0 0;
  font-size: ${fontSize(13)};
  color: ${gray01};
`;

const TagIcon = styled(Icon)`
  margin-right: ${spacing(4)};
  width: 14px !important;
  height: 14px !important;
  color: ${gray01};
`;
